import { render, staticRenderFns } from "./estates-home-grid.vue?vue&type=template&id=640eeeeb&scoped=true&"
import script from "./estates-home-grid.vue?vue&type=script&lang=js&"
export * from "./estates-home-grid.vue?vue&type=script&lang=js&"
import style0 from "./estates-home-grid.vue?vue&type=style&index=0&id=640eeeeb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640eeeeb",
  null
  
)

export default component.exports